// Icon
import * as React from 'react';
export default function Icon(props) {
  return /*#__PURE__*/React.createElement("i", {
    className: "rmel-iconfont rmel-icon-" + props.type
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-markdown-editor-lite/esm/components/Icon/index.js
// module id = 20
// module chunks = 0